import { RentalDispense } from "@/models/rental-dispense.model"
import { RentalDispenseRepository } from "@/repositories/rental-dispense-repository"
import { useRentalDispenseStore } from "@/store/rental-dispense.store"
import { type IRentalDispense } from "@/interfaces/api/rental-dispense.interface"
import { RentalMutationController } from "@/controllers/model-controllers/abstract/rental-mutation-controller"
import { Project } from "@/models/project.model"

export default class RentalDispenseController extends RentalMutationController<
  RentalDispense,
  IRentalDispense,
  RentalDispenseRepository
> {
  constructor() {
    const { pushToRelatedObjects, removeFromRelatedObjects } = useRentalDispenseStore()

    const storeFunctionsConfig = {
      onCreate: pushToRelatedObjects,
      onDelete: removeFromRelatedObjects
    }

    super(RentalDispense, storeFunctionsConfig, new RentalDispenseRepository())
  }

  public async getReturnableIssuancesList(
    text: string,
    project?: Project
  ): Promise<RentalDispense[]> {
    const data = await this.getReturnableIssuancesListData(text, project)
    const models = await this.storeFunctions.createModel(data)
    const rentalDispenseStore = useRentalDispenseStore()
    rentalDispenseStore.addToReturnableRentalDispenses(models)
    return models
  }
}
